export default "__VITE_ASSET__DlVmmS2I__"